import React, { useEffect, useState } from "react";
import {
  FaGithub,
  FaTwitter,
  FaFacebookF,
  FaLinkedin,
  FaYoutube,
  FaTwitch,
} from "react-icons/fa";
import Sketchfab from "../../assets/images/sketchfab-icon.png";
import { socialprofils } from "../../content_option";
import styled from "styled-components";

const StyledDiv = styled.div`
  top: 50%;
  width: 20px;
  height: 200px;
  margin-top: -85px;
  position: fixed !important;
  bottom: 0px !important;
  margin-left: 20px;

  @media (max-width: 991px) {
    position: ${props => props.$fixed ? 'fixed !important' : 'relative !important'};
    width: 100vw;
    display: flex;
    flex-direction: row-reverse;
    justify-content: center;
    align-items: flex-end;
    bottom: 10px !important;
    margin-left: 0px !important; 
    margin-top: 0px !important;
    height: auto !important;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;

    @media (max-width: 991px) {
      margin-bottom: 20px;
      margin-top: 20px;
    }

    li {
      display: block;
      font-size: 12px;
      text-align: center;
      margin-bottom: 10px;
      transition: all 0.3s;

      @media (max-width: 991px) {
        display: inline;
        margin-bottom: 29px;
        margin-right: 10px;
      }
    }
  }

  svg {
    width: 1.3em;
    height: 1.3em;
    fill: var(--text-color);
  }

  .sketchfabFiltered {
    filter: invert();
  }

  p {
    top: 70px;
    left: -24px;
    width: 68px;
    height: 20px;
    color: var(--text-color);
    font-size: 12px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    position: relative;
    transform: rotate(-90deg);

    @media (max-width: 991px) {
      top: unset;
      left: unset;
      width: unset;
      height: unset;
      white-space: nowrap;
      position: relative;
      transform: unset;
      font-size: 17px;
      margin-right: 65px;
    }

    &:after {
      top: 9px;
      right: -48px;
      width: 40px;
      height: 1px;
      content: "";
      display: block;
      position: absolute;
      background-color: var(--text-color);
    }
  }
`;

export const Socialicons = (params) => {
  const [filterEnabled, setFilterEnabled] = useState(false);
  const [fixed, setFixed] = useState(false);


  useEffect(() => {
    const handleThemeChange = (event) => {
      setFilterEnabled(event.detail === "dark");
    };
    const handlePageChange = (event) => {
      if(window.location.pathname === "/portfolio" || window.location.pathname === "/about") {
        setFixed(false);
      } else {
        setFixed(true);
      }
    };

    window.addEventListener("themeChanged", handleThemeChange);
    window.addEventListener("pageChanged", handlePageChange);
    setFilterEnabled(localStorage.getItem("theme") === "dark");

    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
      window.removeEventListener("pageChanged", handlePageChange);
    };
  }, []);

  
  return (
    <StyledDiv $fixed={fixed}>
      <ul>
        {socialprofils.twitter && (
          <li>
            <a href={socialprofils.twitter}>
              <FaTwitter />
            </a>
          </li>
        )}
        {socialprofils.github && (
          <li>
            <a href={socialprofils.github}>
              <FaGithub />
            </a>
          </li>
        )}
        {socialprofils.facebook && (
          <li>
            <a href={socialprofils.facebook}>
              <FaFacebookF />
            </a>
          </li>
        )}
        {socialprofils.linkedin && (
          <li>
            <a href={socialprofils.linkedin}>
              <FaLinkedin />
            </a>
          </li>
        )}
        {socialprofils.youtube && (
          <li>
            <a href={socialprofils.youtube}>
              <FaYoutube />
            </a>
          </li>
        )}
        {socialprofils.twitch && (
          <li>
            <a href={socialprofils.twitch}>
              <FaTwitch />
            </a>
          </li>
        )}
        {socialprofils.sketchfab && (
          <li>
            <a href={socialprofils.sketchfab}>
              {filterEnabled && (
                <img
                  className="sketchfabFiltered"
                  src={Sketchfab}
                  style={{ height: "15px" }}
                  alt="Sketchfab"
                />
              )}
              {!filterEnabled && (
                <img src={Sketchfab} style={{ height: "15px" }} alt="Sketchfab" />
              )}
            </a>
          </li>
        )}
      </ul>
      <p>Follow Me</p>
    </StyledDiv>
  );
};
